(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doos-header"]) return;
  try {
    
  window.SectionHeader = (function () {
    function SectionHeader() {
      this._run();
    }

    SectionHeader.prototype = {
      _run: function () {
        $(document).on('click', '.main-header .cart-icon', function () {
          if (!$('body').hasClass('cart-drawer-open')) $('body').addClass('cart-drawer-open cart-open');
        });

        $(document).on('click', '.cart-drawer .fallback-text', function () {
          if ($('body').hasClass('cart-open')) $('body').removeClass('cart-open cart-drawer-open');
        });

        $(document).on('click', '.DrawerOverlay', function () {
          $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
        });
      },

      onSelect: function () {
        this._run();
      },

      onUnload: function () {
        $('.main-header .cart-icon').off('click');
        $('.cart-drawer .fallback-text').off('click');
        $('.DrawerOverlay').off('click');
      },
    };

    return new SectionHeader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doos-shipping-bar"]) return;
  try {
    
  window.SectionShippingBar = (function () {
    function SectionShippingBar() {
      this._run();
    }

    SectionShippingBar.prototype = {
      _run: function () {
        update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
      },

      onSelect: function () {
        this._run();
      },

      onUnload: function () {},
    };

    return new SectionShippingBar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-old"]) return;
  try {
    
  (function ($) {
    var $document = $(document);
    $document.ready(function () {
      $document.on('click', '.tabs', function () {
        var tabs = $(this),
          scope = tabs.parent().attr('data-tabs-scope');
        tabs.addClass('active').siblings().removeClass('active');
        $(
          '.tabs-content[data-tabs-scope="' +
            scope +
            '"] .tab-content[data-identifier="' +
            tabs.attr('data-target') +
            '"]'
        )
          .addClass('active')
          .siblings()
          .removeClass('active');
        return false;
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-mobile"]) return;
  try {
    
  $(document).on('click', '.jq-icon-fallback-text', function () {
    if ($('body').hasClass('js-drawer-open-left')) $('body').removeClass('js-drawer-open-left');
    else {
      $('.main-content').addClass('is-moved-by-drawer');
      $('.fixed').addClass('is-moved-by-drawer');
      $('.shopify-section header').addClass('is-moved-by-drawer');
      $('.search').addClass('is-moved-by-drawer');
      $('body').addClass('js-drawer-open-left');
    }
  });

  $(document).on('click', '.DrawerOverlay', function () {
    $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
  });

  $(document).on('click', '.mobile-nav__toggle-open,.mobile-nav__link[href^="#"]', function () {
    var instance = $(this);

    instance.parent().siblings('.child').slideToggle(400);

    if (instance.is('.mobile-nav__link')) {
      instance = instance.siblings('.mobile-nav__toggle-open');
    }

    if (instance.hasClass('anime-plus-ver')) {
      instance.removeClass('anime-plus-ver anime-plus-hor');
    } else {
      instance.addClass('anime-plus-ver anime-plus-hor');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-promotional"] && !Shopify.designMode) return;
  try {
    
  window.SectionSliderPromotional = (function () {
    function SectionSliderPromotional() {
      this.settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
        nextArrow: '<button type="button" class="slick-next">&rang;</button>',
        arrows: true,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1019,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      };

      this._run();
    }

    SectionSliderPromotional.prototype = {
      onLoad: function () {
        this._run();
      },

      _run: function () {
        var slider,
          autoplay,
          autoplaySpeed,
          settings = this.settings;

        jQuery('[id^="slider-promotional-"]').each(function () {
          slider = '#promotional-' + $(this).data('slider');

          autoplay = jQuery(slider).data('autoplay');
          autoplaySpeed = jQuery(slider).data('speed');

          if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
            autoplay = true;
          }

          if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
            autoplaySpeed = 800;
          }

          settings.autoplay = autoplay;
          settings.autoplaySpeed = autoplaySpeed;

          jQuery(slider).not('.slick-initialized').slick(settings);
        });
      },
    };

    return new SectionSliderPromotional();
  })();

  } catch(e) { console.error(e); }
})();
})();
